import { defineMessages } from 'react-intl';

const messages = defineMessages({
  ByArtist: {
    defaultMessage: 'by {artistName}',
    description: 'The artist who created this work.'
  }
});

export default messages;
